module.exports = __webpack_public_path__ + "static/media/piper-traffic-light-red.36b41a14.svg";